/** In this file entities are declared */
import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../../utils";

const ModuleDefinition = {
  name: "Travel Window",
  entityName: "travelWindow",
  entities: [],
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section

  translation: {
    translated: false,
    fieldName: "translations",
    displayName: "translations",
    widget: "translations",
    entityProperty: "filterOptionTranslations",
  },
  sorting: {
    property: "filterOptionPosition",
    sortable: false,
  },
  fields: {
    list: [
      {
        fieldName: "startDate",
        displayName: "Start Date",
      },
      {
        fieldName: "endDate",
        displayName: "End Date",
      },
      {
        fieldName: "weekDays",
        displayName: "Days of the week",
      },
    ],
    form: [
      {
        fieldName: "restrictions",
        widget: "openTravel",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Enter a date",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        className: "tickerInput",
      },
    ],
  },
  validation: {},
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
